import { clamp } from '../../../utils/clamp';

export const zooming = (selectorImg, selectorResult) => {
    /** ****** Property start ****** */
    const img = document.querySelector(selectorImg);
    const focus = document.querySelector('.img-zoom-lens');
    const result = document.querySelector(selectorResult);
    let mainImg = img.src;
    let resultImg = img.src;
    let cx;
    let cy;
    let borderX;
    let borderY;
    const COEFFICIENT_SIDE_FOCUS = focus.offsetWidth / focus.offsetHeight;
    let mainSideK = 1;
    let bigSideK = 1;
    let sideK = 1;
    let prevMoveEvent = null;
    /** ****** Property end ****** */

    /** ******* Methods start ***** */

    const show = () => {
        focus.classList.add('ready');
        result.classList.add('ready');
    };

    const hide = () => {
        focus.classList.remove('ready');
        result.classList.remove('ready');
    };

    const normalizeFocus = () => {
        if (focus.offsetWidth >= img.offsetWidth) {
            focus.style.width = `${Math.round(img.offsetWidth - 4)}px`;
            focus.style.left = '0px';
            focus.style.height = `${Math.round((img.offsetWidth - 4) / COEFFICIENT_SIDE_FOCUS)}px`;
        }
        if (focus.offsetHeight >= img.offsetHeight) {
            focus.style.height = `${Math.round(img.offsetHeight - 4)}px`;
            focus.style.top = '0px';
            focus.style.width = `${Math.round((img.offsetHeight - 4) * COEFFICIENT_SIDE_FOCUS)}px`;
        }
    };
    const normalizeImg = () => {
        img.style.width = '';
        img.style.height = '';
    };
    const calcZoom = () => {
        cx = result.offsetWidth / focus.offsetWidth;
        cy = result.offsetHeight / focus.offsetHeight;
        const offsetBorderX = img.width < 360 ? 0 : 2;
        borderX = img.width - (focus.offsetWidth + offsetBorderX);
        borderY = img.height - focus.offsetHeight;
        result.style.backgroundSize = `${img.width * cx * sideK}px ${img.height * cy}px`;
    };

    const getCursorPos = e => {
        const coordinates = img.getBoundingClientRect();
        const x = e.pageX - coordinates.left - window.pageXOffset;
        const y = e.pageY - coordinates.top - window.pageYOffset;
        return { x, y };
    };

    const moveFocus = e => {
        e.preventDefault();
        prevMoveEvent = e;
        const pos = getCursorPos(e);
        const offsetX = (img.width - img.width * sideK) / 2;
        const y = Math.round(clamp(pos.y - focus.offsetHeight / 2, 0, borderY));
        const x = Math.round(clamp(pos.x - focus.offsetWidth / 2, 0, borderX));
        focus.style.left = `${x}px`;
        focus.style.top = `${y}px`;
        result.style.backgroundPosition = `${(x - offsetX) * cx * -1}px -${y * cy}px`;
    };

    const getSideK = src => {
        // eslint-disable-next-line
        const img = document.createElement('img');
        img.src = src;
        // operation is sync becouse src was loaded look at app-carousel.js
        return img.naturalWidth / img.naturalHeight;
    };

    const setSrcImg = (mainSrc, resultSrc) => {
        mainImg = mainSrc;
        resultImg = resultSrc || mainSrc;
        result.style.backgroundImage = `url("${resultImg}")`;
        img.src = mainImg;
        normalizeImg(); // for next 2 line: browser try render img with float number, but property from dom return int number
        img.style.width = `${img.offsetWidth}px`;
        img.style.height = `${img.offsetHeight}px`;
        mainSideK = getSideK(img.src);
        bigSideK = getSideK(resultImg);
        sideK = 1 - (mainSideK - bigSideK);
        normalizeFocus();
        if (prevMoveEvent) moveFocus(prevMoveEvent);
        calcZoom();
    };

    const resizeFocus = e => {
        e.preventDefault();
        const newSize = e.deltaY < 0 ? focus.offsetWidth + 5 : focus.offsetWidth - 5;
        const validSize = clamp(newSize, 1, img.offsetWidth - 1);
        if (validSize / COEFFICIENT_SIDE_FOCUS > img.offsetHeight) {
            focus.style.height = `${Math.round(img.offsetHeight)}px`;
            focus.style.width = `${Math.round(img.offsetHeight * COEFFICIENT_SIDE_FOCUS)}px`;
        } else {
            focus.style.height = `${Math.round(validSize / COEFFICIENT_SIDE_FOCUS)}px`;
            focus.style.width = `${Math.round(validSize)}px`;
        }
        calcZoom();
        moveFocus(e);
    };
    /** ******* Methods end ***** */

    /** ******* Initialization and set event start ***** */
    setSrcImg(mainImg, resultImg);
    calcZoom();
    focus.addEventListener('mousemove', moveFocus);
    img.addEventListener('mousemove', moveFocus);
    focus.addEventListener('wheel', resizeFocus);
    /** ******* Initialization and set event end ****** */

    /** ** API **** */
    return {
        setSrcImg,
        show,
        hide,
        on(type, callback) {
            focus.addEventListener(type, callback);
        },
        calcZoom,
        normalizeImg,
    };
};
